export const darkTheme = {
  darkTheme: {
    announcementTitle: "Agora temos um tema escuro no app 🎉",
    announcementDisclaimer: "Você pode mudar depois no menu",
    tryNow: "Teste agora:",
  },
};
